<template>
  <div>
    <countdown v-if="currentStage === 'countdown'" @startGame="startGame" />
    <puzzle
      v-if="currentStage === 'puzzle'"
      :number="puzzleNumber"
      :name="`/img/Test-${puzzleNumber}.jpg`"
      :options="['1', '2', '3']"
      :keyboard="false"
      :countdown="false"
      :hideSkip="true"
      @complete="puzzleComplete"
    />
    <pause
      v-if="currentStage === 'pause'"
      :solution="solutionText"
      :legCorrect="legCorrect"
      @nextPuzzle="nextPuzzle"
    />
    <game-over
      v-if="currentStage === 'gameover'"
      :user="user.name"
      :time="userTime"
      :error="error"
    />
  </div>
</template>

<script>
import Countdown from '@/components/Countdown'
import Puzzle from '@/components/Puzzle'
import Pause from '@/components/Pause'
import GameOver from '@/components/GameOver'

export default {
  components: {
    Countdown,
    Puzzle,
    Pause,
    GameOver,
  },

  data: function() {
    return {
      puzzleNumber: 1,
      currentStage: 'countdown',
      choices: [],
      times: [],
      userScore: '',
      userTime: 0,
      user: {},
      users: {},
      error: 1,

      solution: [
        [105000, 90000, 120000],
        [95000, 80000, 100000],
        [150000, 135000, 135000],
      ],
    }
  },

  computed: {
    solutionText: function() {
      const indexOfChoice = ['1', '2', '3'].indexOf(
        this.choices[this.puzzleNumber - 1]
      )
      return `${this.solution[this.puzzleNumber - 1].indexOf(
        Math.min(...this.solution[this.puzzleNumber - 1])
      ) + 1} (${Math.min(...this.solution[this.puzzleNumber - 1]) /
        1000}s) - You answered ${this.choices[this.puzzleNumber - 1]} (${this
        .solution[this.puzzleNumber - 1][indexOfChoice] / 1000}s) `
    },
    legCorrect: function() {
      return (
        ['1', '2', '3'].indexOf(this.choices[this.puzzleNumber - 1]) ===
        this.solution[this.puzzleNumber - 1].indexOf(
          Math.min(...this.solution[this.puzzleNumber - 1])
        )
      )
    },
  },

  methods: {
    startCountdown: function(user) {
      this.user = user
      this.setUserStarted(user.id)
      this.currentStage = 'countdown'
    },

    saveUserResult: function() {
      return Promise.resolve().then(() => {
        this.error = 0
      })
    },

    startGame: function() {
      this.currentStage = 'puzzle'
    },

    puzzleComplete: function(result) {
      this.choices.push(result.choice)
      this.times.push(result.time)

      this.currentStage = 'pause'
    },

    nextPuzzle: function() {
      if (this.puzzleNumber === this.solution.length) {
        this.currentStage = 'gameover'

        this.userTime = this.scoreUser()

        this.saveUserResult()
      } else {
        this.puzzleNumber += 1
        this.currentStage = 'puzzle'
      }
    },

    displayTime: function(milliseconds) {
      const minutes = Math.floor(milliseconds / 60000)
      const millisecondsOverMinutes = milliseconds - minutes * 60000
      const seconds = Math.round(millisecondsOverMinutes / 10) / 100

      return `${this.twoDigits(minutes)}:${this.twoDigits(seconds)}`
    },

    twoDigits: function(number) {
      const splitNumber = number.toString().split('.')
      if (splitNumber.length > 1 && splitNumber[0].toString().length < 2)
        return `0${splitNumber[0].toString()}.${splitNumber[1]}`
      else if (number.toString().length < 2) return `0${number.toString()}`
      else return number
    },

    scoreUser: function() {
      let time = 0
      let i = 0

      while (i < this.choices.length) {
        const indexOfChoice = ['1', '2', '3'].indexOf(this.choices[i])
        time += this.times[i]
        time += this.solution[i][indexOfChoice]

        i += 1
      }

      return time
    },
  },
}
</script>
